module.exports = __webpack_public_path__ + "img/OBCINA LOSKA DOLINA.77eaaeff.png";